/**
 * How many listings carry each filter option, counted from one page of listings
 * ({ categoryLevel1: { guitars: 3 }, condition: { new: 1, used: 0 }, ... }).
 */

const CATEGORY_LEVELS = ['categoryLevel1', 'categoryLevel2', 'categoryLevel3', 'categoryLevel4'];
const UNCOUNTED_SCHEMA_TYPES = ['price', 'dates', 'keywords', 'category'];

// A filter's options: listing fields keep them in enumOptions, some default filters in
// filterConfig.options, others in options
const enumOptionsOf = config =>
  config.enumOptions || config.filterConfig?.options || config.options || null;

/**
 * Counts each category level's values and each enum filter's options over the given
 * listings. Options no listing has count 0.
 */
export const countFiltersFromListings = (listings, filterConfigs) => {
  const counts = {};
  const publicDataOf = listing => listing.attributes?.publicData || {};

  CATEGORY_LEVELS.forEach(levelKey => {
    counts[levelKey] = {};
    listings.forEach(listing => {
      const value = publicDataOf(listing)[levelKey];
      if (value) counts[levelKey][value] = (counts[levelKey][value] || 0) + 1;
    });
  });

  filterConfigs.forEach(config => {
    const { key, schemaType } = config;
    const enumOptions = enumOptionsOf(config);
    if (!key || !enumOptions || UNCOUNTED_SCHEMA_TYPES.includes(schemaType)) return;

    counts[key] = {};
    enumOptions.forEach(opt => {
      const optionValue = opt.option || opt.key;
      if (typeof optionValue === 'string') counts[key][optionValue] = 0;
    });
    listings.forEach(listing => {
      const value = publicDataOf(listing)[key];
      if (!value) return;
      (Array.isArray(value) ? value : [value]).forEach(v => {
        if (counts[key][v] !== undefined) counts[key][v] += 1;
      });
    });
  });

  return counts;
};

/**
 * The counts for a listings query's answer, only when that one page held every listing
 * it matched: past one page, counting it would show too few, so there are none (the
 * filters then show their options without numbers).
 */
export const filterCountsFromResponse = (response, filterConfigs) => {
  const listings = response?.data?.data || [];
  const totalItems = response?.data?.meta?.totalItems;
  const isComplete = totalItems == null || totalItems <= listings.length;
  return isComplete ? countFiltersFromListings(listings, filterConfigs) : {};
};
